import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import boon from '../../../assets/images/BoonViewIcon.svg';
import CarotDownFilled from '../../../assets/images/caret-down-fill.svg';
import CarotUpFilled from '../../../assets/images/caret-up-fill.svg';
import defaultLogo from '../../../assets/images/CompanyDefaultLogo.svg';
import plusIcon from '../../../assets/images/plusIcon.svg';
import { setCurrentOrganization } from '../../../redux/actions/organizationActions';
import { selectCurrentUser } from '../../../selectors/authSelectors';
import {
  getUserOrganizationsMemoized,
  selectCurrentOrganization,
  selectOrganizationLoading,
} from '../../../selectors/organizationSelectors';

import styles from './DropDown.module.scss';

const DropDown = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { companyName } = useParams();
  const userOrganizations = useSelector(getUserOrganizationsMemoized);
  const userOrganizationsLoading = useSelector(selectOrganizationLoading);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const currentUser = useSelector(selectCurrentUser);
  const navigate = useNavigate();
  const location = useLocation();
  const [, setSearchParams] = useSearchParams();
  const [allOrganizations, setAllOrganization] = useState();
  const [selectedOrganization, setSelectedOrganization] = useState();
  const identifier = localStorage.getItem('orgIdentifier');
  const [selectedOrganizationLogo, setSelectedOrganizationLogo] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const boonViewNavigation =
    selectedOrganization && JSON.parse(localStorage.getItem('selectedOrganization'))?.name === 'Boon' && identifier;
  const handleBoonViewOrganization = () => {
    const organization = { id: null, name: 'Boon', logo_image_thumb: '' };
    dispatch(setCurrentOrganization(organization));
    localStorage.removeItem('orgIdentifier');
  };

  const handleSelectOrganization = (org) => {
    if (org.general_setting_identifier === currentOrganization?.general_setting_identifier) {
      return;
    }

    if (localStorage.getItem('referralFlowData')) {
      localStorage.removeItem('referralFlowData');
    }

    localStorage.removeItem('orgIdentifier');
    const params = new URLSearchParams(location.search);
    setSearchParams({});
    if (params.get('company')) {
      params.delete('company');
    }
    if (companyName) {
      navigate(window.location.pathname.replace(companyName, org.general_setting_identifier));
    } else {
      navigate(0);
    }
    dispatch(setCurrentOrganization(org));
    localStorage.setItem('selectedOrganization', JSON.stringify(org));
  };

  useEffect(() => {
    setSelectedOrganization(currentOrganization?.name);
    setSelectedOrganizationLogo(currentOrganization?.logo_image_thumb || defaultLogo);
  }, [currentOrganization]);

  useEffect(() => {
    if (currentUser?.boon_view && userOrganizations?.length > 0) {
      setAllOrganization([...userOrganizations, { organization: { id: null, name: 'Boon', logo_image_thumb: '' } }]);
    } else {
      setAllOrganization(userOrganizations);
    }
  }, [userOrganizations, currentUser]);

  if (!currentOrganization && !userOrganizationsLoading) {
    return null;
  }
  return (
    <Dropdown className={styles.dropdownCustom} show={isOpen} onToggle={() => setIsOpen((prev) => !prev)}>
      <Dropdown.Toggle variant="success" id="dropdown-basic" className={styles['dropdownCustom-toggle']}>
        <div
          className={styles.dropDownContainer}
          onClick={() => {
            if (
              allOrganizations?.length === 0 &&
              JSON.parse(localStorage.getItem('selectedOrganization'))?.name === 'Boon' &&
              identifier
            ) {
              handleBoonViewOrganization();
            }
          }}
          role="button"
          tabIndex={0}
          onKeyPress={handleBoonViewOrganization}
        >
          {userOrganizationsLoading && (
            <>
              {boonViewNavigation ? (
                <>
                  <div>
                    <img src={boon} alt="logo" className={styles.currentSelectedImg} />
                  </div>
                  <div className={styles.orgName}>{t('appName')}</div>
                </>
              ) : (
                <>
                  <div>
                    <img
                      src={selectedOrganization !== 'Boon' ? selectedOrganizationLogo : boon}
                      alt="logo"
                      className={styles.currentSelectedImg}
                    />
                  </div>
                  <div className={styles.orgName}>{selectedOrganization}</div>
                </>
              )}

              {allOrganizations?.length > 1 && (
                <div className={styles.toggleImgDiv}>
                  {isOpen ? (
                    <img src={CarotUpFilled} alt="toggle" className={styles.toggleImg} />
                  ) : (
                    <img src={CarotDownFilled} alt="toggle" className={styles.toggleImg} />
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </Dropdown.Toggle>
      {userOrganizations && allOrganizations?.length > 1 && (
        <Dropdown.Menu className={`${styles['dropdownCustom-menu']} ${styles.scrollbarCustom}`}>
          {allOrganizations.map((org, index) => (
            <Dropdown.Item
              key={org?.organization?.id ? `org-${org.organization.id}` : `org-${index}`}
              onClick={() => handleSelectOrganization(org?.organization)}
            >
              <div className={styles.dropDownBox}>
                <div className={styles.dropDownImgBox}>
                  {org?.organization?.name !== 'Boon' ? (
                    <img
                      src={org?.organization?.logo_image_thumb || defaultLogo}
                      alt="logo"
                      className={styles.dropDownImg}
                    />
                  ) : (
                    <img src={boon} alt="logo" className={styles.currentSelectedImg} />
                  )}
                </div>
                <div className={styles.dropDownText}>{org?.organization?.name}</div>
              </div>
            </Dropdown.Item>
          ))}
          {currentUser?.email === 'hello@goboon.co' && (
            <Dropdown.Item onClick={() => navigate('/createOrganization')} className={styles.createOrgItem}>
              <div className={styles.dropDownBox}>
                <div className={styles.dropDownImgBox}>
                  <img src={plusIcon} alt="plus" className={styles.dropDownImg} />
                </div>
                <div className={styles.dropDownText}>Create Organization</div>
              </div>
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};

export default DropDown;
